import React, { Component } from "react";
import FormGroup from "../FormGroup/FormGroup";
// generic component workaround
const FormGroupOfStringAndHtmlTextAreaElement = FormGroup;
class TextArea extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleChange = this._handleChange.bind(this);
    }
    render() {
        const { props } = this;
        return (<textarea {...props.attrs} className="textarea" value={props.value} onChange={this._handleChange}/>);
    }
    _handleChange(event) {
        this.props.onChange(event.currentTarget.value, event);
    }
}
const TextareaFormGroup = (props) => (<FormGroupOfStringAndHtmlTextAreaElement {...props}>
		{controlState => (<TextArea {...controlState}/>)}
	</FormGroupOfStringAndHtmlTextAreaElement>);
export default TextareaFormGroup;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/TextAreaFormGroup/TextAreaFormGroup.tsx